import { useState } from "react";
import type { User } from "../../types/auth";

interface UserProfileProps {
  user: Pick<User, "name" | "avatar_url"> | null;
  showName?: boolean;
}

export function UserProfile({ user, showName = false }: UserProfileProps) {
  const [imgError, setImgError] = useState(false);

  if (!user) return null;

  const showImage = user.avatar_url && !imgError;

  return (
    <div
      className={`flex min-w-0 items-center ${showName ? "gap-3" : ""}`}
      aria-label={`User profile: ${user.name}`}
      title={user.name}
    >
      {showImage ? (
        <img
          src={user.avatar_url ?? undefined}
          alt={user.name}
          className="h-9 w-9 rounded-full border-2 border-white object-cover shadow-sm"
          referrerPolicy="no-referrer"
          onError={() => setImgError(true)}
        />
      ) : (
        <div className="flex h-9 w-9 items-center justify-center rounded-full border-2 border-white bg-[#FFE1BE] shadow-sm">
          <span className="text-sm font-bold text-[#A94E00]">
            {user.name.charAt(0).toUpperCase()}
          </span>
        </div>
      )}
      <span className={showName ? "min-w-0 truncate text-sm font-semibold text-[#171714]" : "sr-only"}>{user.name}</span>
    </div>
  );
}
